











import Vue from 'vue'
import queryString, { ParsedQuery } from 'query-string'
import * as types from '@/store/modules/play/types'
import * as scoreUtil from '@/utils/score'

interface State {
  isCopyDone: boolean;  // クリップボードにコピーしたか
  timer: number;
}

export default Vue.extend({
  name: 'DebugScoreUrl',

  data (): State {
    return {
      isCopyDone: false,
      timer: NaN,
    }
  },

  computed: {
    /**
     * スコア
     */
    score (): types.SoundOnScore[] {
      return this.$store.state[types.moduleName].score
    },

    /**
     * クエリー文字列
     */
    query (): ParsedQuery {
      // 複製を返す（stateを返すと値が直接変更されてしまう可能性があるため）
      return Object.assign({}, this.$store.state.query)
    },

    /**
     * パーマリンク
     */
    permalink (): string {
      const encodedScore = scoreUtil.scoreToQuery(this.score)
      const mergedQuery = Object.assign(this.query, {
        score: encodedScore,
      })
      return `${document.location.origin}${document.location.pathname}?${queryString.stringify(mergedQuery)}${document.location.hash}`
      // return `${document.location.origin}`
    },
  },

  methods: {
    /**
     * パーマリンクをクリップボードにコピー
     */
    copyPermalink () {
      this.$refs.permalink.select()
      this.isCopyDone = document.execCommand('copy')

      if (!isNaN(this.timer)) {
        window.clearTimeout(this.timer)
      }

      // 一定時間でコピー完了から復帰
      this.timer = window.setTimeout(() => {
        this.isCopyDone = false
      }, 1500)
    },
  },
})
